import React, { useMemo } from 'react';
import { Select } from 'antd';
import { ICustomSelectProps } from 'store/ducks/Global/types';
import * as Styled from './CustomSelect.styled';

export const CustomSelect: React.FC<ICustomSelectProps> = ({
  options,
  placeholder,
  size,
  filters = false,
  disabled,
  ...rest
}) => {
  const formattedOptions = useMemo(() => {
    if (!options) return [];

    // Handle array of strings
    if (
      Array.isArray(options) &&
      options.length > 0 &&
      typeof options[0] === 'string'
    ) {
      return options.map((option: string) => ({
        label: option,
        value: option
      }));
    }

    // Handle array of objects with label/value or options property
    if (Array.isArray(options)) {
      return options.map((option: any) => {
        if (typeof option === 'object' && option.options) {
          return {
            label: option.options,
            value: option.options
          };
        }
        return option;
      });
    }

    return options;
  }, [options]);

  return (
    <>
      {filters ? (
        <Styled.FiltersWrapper>
          <Select
            placeholder={placeholder}
            options={formattedOptions}
            virtual={false}
            listHeight={256}
            {...rest}
            disabled={disabled}
          />
        </Styled.FiltersWrapper>
      ) : (
        <Styled.SelectWrapper size={size}>
          <Select
            placeholder={placeholder}
            options={formattedOptions}
            virtual={false}
            listHeight={256}
            {...rest}
            disabled={disabled}
          />
        </Styled.SelectWrapper>
      )}
    </>
  );
};
